import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureTrackingFromUrl } from "./lib/tracking";

Sentry.init({
  dsn: "https://b094d29d0bc512e27ad66895c35f8695@o4510056771420160.ingest.de.sentry.io/4510056772599888",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: false,
});

captureTrackingFromUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
